import React from "react";

export default function ViewTrainingEvents({ event }) {
  return (
    <div style={{ padding: "16px", fontFamily: "'Arial', sans-serif" }}>
      <h2 style={{ fontSize: "20px", marginBottom: "12px", color: "#333" }}>
        Event Details
      </h2>
      {event ? (
        Array.isArray(event) ? (
          <div>
            {event.map((e, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #ddd",
                  padding: "12px",
                  borderRadius: "6px",
                  backgroundColor: "#f4f4f4",
                  marginBottom: "10px",
                }}
              >
                <p style={{ margin: "6px 0" }}>
                  <strong>Training Name:</strong> {e.title}
                </p>
                <p style={{ margin: "6px 0" }}>
                  <strong>Agenda:</strong> {e.Description}
                </p>
                <p style={{ margin: "6px 0" }}>
                  <strong>Start:</strong> {new Date(e.start).toLocaleDateString()}
                </p>
                <p style={{ margin: "6px 0" }}>
                  <strong>End:</strong> {new Date(e.end).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              border: "1px solid #ddd",
              padding: "12px",
              borderRadius: "6px",
              backgroundColor: "#f4f4f4",
            }}
          >
            <p style={{ margin: "6px 0" }}>
              <strong>ID:</strong> {event.id}
            </p>
            <p style={{ margin: "6px 0" }}>
              <strong>Title:</strong> {event.title}
            </p>
            <p style={{ margin: "6px 0" }}>
              <strong>Agenda:</strong> {event.agenda}
            </p>
            <p style={{ margin: "6px 0" }}>
              <strong>Start:</strong> {new Date(event.start).toLocaleString()}
            </p>
            <p style={{ margin: "6px 0" }}>
              <strong>End:</strong> {new Date(event.end).toLocaleString()}
            </p>
          </div>
        )
      ) : (
        <p style={{ color: "#555", fontSize: "14px" }}>
          No event selected. Click on an event to view its details.
        </p>
      )}
    </div>
  );
}
